
export const environment = {
  production: true,
  mediaConfig: 'daimleragmemediaprod',
  apiBaseUrl:'https://api.media.mercedes-benz.com',
  mediaDeliveryUrl:'https://api.media.mercedes-benz.com/jsonapi/image/deliver',
  embedUrl:'https://stream.media.mercedes-benz.com',
  loginUrl:'https://login.media.mercedes-benz.com',
  CSRFTokenHeader:'X-MEMEDIA-CSRF-TOKEN',
  mapApiKey:'HaugiwRK8T3AdSvW3X6qG50NTGYdYTY3-jwvqiQt8mU',
  sitesToTrack:'["media.mercedes-benz.com", "stream.media.mercedes-benz.com"]',
  connectionString:'InstrumentationKey=c2a9e96b-e0b1-46d2-91df-682559ecab5c;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=6c1025ac-85ba-49b3-81ec-dadebf25b8a8',
  frontendUrl:'https://media.mercedes-benz.com',
  siteMapUrl:'https://api.media.mercedes-benz.com/jsonapi/sitemap/index',
  ssrBasicAuthUser:'',
  ssrBasicAuthPassword:'',
  i18nVersion:'0cfd9eb45b'
};
